import React from 'react'
import Image from 'components/Common/Image/Image'
import styled from 'styled-components'
import { rem } from 'polished'

const ImageContainer = styled.div`
  position: relative;
  min-height: ${rem(80)};
  width: 100%;
  aspect-ratio: 2 / 1;
  overflow: hidden;
`

/**
 * @NOTE this is NOT a proper SVG. Due to time constraints we've had to put this temp version for now
 * @TODO replace with proper SVG
 * */
function TuroLogo() {
  return (
    <ImageContainer>
      <Image
        image={{ id: 'turo-logo' }}
        fit="center"
        objectFit="contain"
        alt="Turo Logo"
      />
    </ImageContainer>
  )
}

export default TuroLogo
